import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

// Visual 3: two tabs, each item a card linking to its page.
const PEOPLE = [
  { t: 'A senior appointment where getting it wrong is expensive', href: '/contact' },
  { t: 'A succession question the board has asked', href: '/leadership-succession-intelligence' },
  { t: 'A cohort of high potentials who need to be developed and measured again', href: '/leadership-succession-intelligence' },
  { t: 'People stepping into roles materially bigger than the last', href: '/contact' },
  { t: 'A year-end review that needs evidence behind the rating', href: '/diagnostics' },
  { t: 'Women ready for senior roles, and what the organisation has to change for them', href: '/contact' },
  { t: 'A sales force where some people are in the wrong seat', href: '/contact' },
  { t: 'A graduate intake or assessment centre', href: '/early-career-selection' },
];

const ORG = [
  { t: 'A strategy session coming up, and a team that has to deliver what it agrees', href: '/contact' },
  { t: 'A culture that is not matching the strategy', href: '/advisory' },
  { t: 'A team that achieves less than the people in it could', href: '/contact' },
];

const TabButton = ({ active, children, onClick, testid }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    className={`px-5 sm:px-6 py-3 rounded-lg font-semibold text-sm sm:text-base transition-all duration-300 ${
      active ? 'bg-[#2693d0] text-white' : 'bg-white text-slate-600 border border-slate-200 hover:border-[#2693d0] hover:text-[#2693d0]'
    }`}
  >
    {children}
  </button>
);

export const WhenOrganisationsCall = () => {
  const [tab, setTab] = useState('people');
  const items = tab === 'people' ? PEOPLE : ORG;

  return (
    <div data-testid="when-organisations-call">
      <div className="flex flex-wrap gap-3 mb-8">
        <TabButton active={tab === 'people'} onClick={() => setTab('people')} testid="tab-people">Decisions about people</TabButton>
        <TabButton active={tab === 'org'} onClick={() => setTab('org')} testid="tab-org">Decisions about the organisation</TabButton>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {items.map((item) => (
          <a
            key={item.t}
            href={item.href}
            className="group bg-white rounded-xl border border-slate-200 shadow-sm p-5 sm:p-6 flex items-start justify-between gap-4 hover:border-[#2693d0] hover:shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#2693d0]"
          >
            <span className="text-slate-700 text-sm sm:text-base leading-relaxed">{item.t}</span>
            <ArrowRight size={18} className="text-[#2693d0] flex-shrink-0 mt-1 group-hover:translate-x-1 transition-transform duration-300" aria-hidden="true" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default WhenOrganisationsCall;
